import { useState } from 'react';
import { navigate } from '../App';
import { getStoredName, storeName } from '../storage';

const STEPS = [
  { title: 'Start a session', body: 'One click creates a room with an unguessable link. No account, no install.' },
  { title: 'Share the link', body: 'Everyone who opens it joins the same table and sees each other in real time.' },
  { title: 'Estimate together', body: 'Cards stay face down until the reveal, so nobody anchors on the first number.' },
];

export const Landing = () => {
  const [name, setName] = useState(getStoredName());
  const [creating, setCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const createRoom = async () => {
    setCreating(true);
    setError(null);
    try {
      const response = await fetch('/api/rooms', { method: 'POST' });
      if (!response.ok) throw new Error(`Server responded ${response.status}`);
      const { roomId } = (await response.json()) as { roomId: string };
      if (name.trim()) storeName(name.trim());
      navigate(`/r/${roomId}`);
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : 'Could not reach the server.');
      setCreating(false);
    }
  };

  return (
    <div className="landing">
      <main className="landing-inner">
        <div className="landing-mark" aria-hidden="true">
          <span className="mini-card">3</span>
          <span className="mini-card">5</span>
          <span className="mini-card">8</span>
        </div>

        <h1>Planning Poker</h1>
        <p className="lede">
          Real-time estimation for your team. Everyone picks a card in private, then all cards flip
          at once.
        </p>

        <form
          className="landing-form"
          onSubmit={(event) => {
            event.preventDefault();
            void createRoom();
          }}
        >
          <label className="field">
            <span>Your name</span>
            <input
              value={name}
              onChange={(event) => setName(event.target.value)}
              placeholder="e.g. Max"
              maxLength={32}
              autoComplete="nickname"
            />
          </label>
          <button type="submit" className="btn btn-primary btn-lg" disabled={creating}>
            {creating ? 'Creating…' : 'Start a session'}
          </button>
        </form>

        {error && <p className="landing-error">{error}</p>}

        <ol className="steps">
          {STEPS.map((step, index) => (
            <li key={step.title}>
              <span className="step-number">{index + 1}</span>
              <div>
                <h2>{step.title}</h2>
                <p>{step.body}</p>
              </div>
            </li>
          ))}
        </ol>
      </main>

      <footer className="landing-footer">
        Rooms live in memory only and disappear once everyone has left.
      </footer>
    </div>
  );
};
